module.exports = "/assets/data/b41d37264a8d5ed637669e1d764e4a86-EC4R.data.json";